<div #mainBody>
  <mat-nav-list>
    @for (item of menuItems; track item.text) {
      @if(isExpanded) {
        <a mat-list-item href="..." [routerLink]="item.link" [activated]="this.router.url === item.link">
          <div class="center">
            <mat-icon class="item">{{item.icon}}</mat-icon>
            <span style="font-size:10pt;">
              {{ item.text }}
            </span>
          </div>
        </a>
      } @else {
        <a mat-list-item [matTooltip]="item.text" matTooltipShowDelay="1000" matTooltipPosition="right" [routerLink]="item.link" [activated]="this.router.url === item.link">
          <div class="center">
            <mat-icon>{{item.icon}}</mat-icon>
          </div>
        </a>
      }
    }
  </mat-nav-list>
</div>